import styled from 'styled-components';

export const StyledDescription = styled.div`
    color: white;
    font-size: 14px;

    & + * {
        margin-top: 10px;
    }
`;